/*
 * @Author: kennthKun c_kunx@163.com
 * @Date: 2022-08-29 18:34:04
 * @LastEditors: kennthKun c_kunx@163.com
 * @LastEditTime: 2022-11-04 11:02:40
 * @FilePath: /kx_component/src/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import '../node_modules/antd/dist/antd.less';
import './kx.less';
import { ConType, ComTypeClass, SearchFormComponents } from './type';
import { getComUi } from './FormComponent';
import Component from './component';
import { FormSchema, acceptArrayFun } from './schema';

import DoubleUploadImg from './components/DoubleUploadImg/DoubleUploadImg';
import UploadImgs from './components/UploadImgs/UploadImgs';
import UploadImg from './components/UploadImg/UploadImg';
import UploadVideo from './components/UploadVideo/UploadVideo';
import ImagePreveEdit from './components/ImagePreveEdit';
const { acceptArray } = acceptArrayFun();
export { Affix } from './lib/Affix';
export { Anchor } from './lib/Anchor';
export { AutoComplete } from './lib/AutoComplete';
export { Alert } from './lib/Alert';
export { Avatar } from './lib/Avatar';
export { BackTop } from './lib/BackTop';
export { Badge } from './lib/Badge';
export { Breadcrumb } from './lib/Breadcrumb';
export { default as Button } from './lib/Button';
export { Calendar } from './lib/Calendar';
export { Card } from './lib/Card';
// export { default as Card } from './lib/Card';
export { Collapse } from './lib/Collapse';
export { Carousel } from './lib/Carousel';
export { Cascader } from './lib/Cascader';
export { Checkbox } from './lib/Checkbox';
export { Col } from './lib/Col';
export { Comment } from './lib/Comment';
export { ConfigProvider } from './lib/ConfigProvider';
export { DatePicker } from './lib/DatePicker';
export { Descriptions } from './lib/Descriptions';
export { Divider } from './lib/Divider';
export { Dropdown } from './lib/Dropdown';
export { Drawer } from './lib/Drawer';
export { Empty } from './lib/Empty';
export { Form } from './lib/Form';
export { Input } from './lib/Input';
export { Image } from './lib/Image';
export { InputNumber } from './lib/InputNumber';
export { Layout } from './lib/Layout';
export { List } from './lib/List';
export { message } from './lib/Message';
export { Menu } from './lib/Menu';
export { Mentions } from './lib/Mentions';
export { Modal } from './lib/Modal';
export { Statistic } from './lib/Statistic';
export { notification } from './lib/Notification';
export { PageHeader } from './lib/PageHeader';
export { Pagination } from './lib/Pagination';
export { Popconfirm } from './lib/Popconfirm';
export { Popover } from './lib/Popover';
export { Progress } from './lib/Progress';
export { Radio } from './lib/Radio';
export { Rate } from './lib/Rate';
export { Result } from './lib/Result';
export { Row } from './lib/Row';
export { Select } from './lib/Select';
export { Skeleton } from './lib/Skeleton';
export { Slider } from './lib/Slider';
export { Space } from './lib/Space';
export { Spin } from './lib/Spin';
export { Steps } from './lib/Steps';
export { Switch } from './lib/Switch';
export { Table } from './lib/Table';
export { Transfer } from './lib/Transfer';
export { Tree } from './lib/Tree';
export { TreeSelect } from './lib/TreeSelect';
export { Tabs } from './lib/Tabs';
export { Tag } from './lib/Tag';
export { TimePicker } from './lib/TimePicker';
export { Timeline } from './lib/Timeline';
export { Tooltip } from './lib/Tooltip';
export { Upload } from './lib/Upload';

export {
  Component,
  acceptArray,
  FormSchema,
  SearchFormComponents,
  ConType,
  ComTypeClass,
  getComUi,
  DoubleUploadImg,
  UploadImgs,
  UploadImg,
  UploadVideo,
  ImagePreveEdit,
};
